<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <list-chargeable-student
            :resources="resources"
            :chargeableId="chargeable"
            :loadedChargeable="loadedChargeable"
          ></list-chargeable-student>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
      <ion-fab-button @click="setCreateModalState(true)">
        <ion-icon :ios="addOutline" :md="addOutline"></ion-icon>
      </ion-fab-button>
    </ion-fab>

    <ion-modal
      :is-open="createModalState"
      @didDismiss="setCreateModalState(false)"
    >
      <base-modal
        title="Assign Student"
        @closeModal="setCreateModalState(false)"
      >
        <create-chargeable-student
          @closeModal="setCreateModalState(false)"
          :chargeable_id="chargeable"
        ></create-chargeable-student>
      </base-modal>
    </ion-modal>
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
import ListChargeableStudent from "../../Components/Due/Chargeable/ListChargeableStudent";
import CreateChargeableStudent from "../../Components/Due/Chargeable/CreateChargeableStudent";
import BaseModal from "../../Base/BaseModal";

import {
  IonGrid,
  IonRow,
  IonCol,
  IonFab,
  IonFabButton,
  IonIcon,
  IonModal,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";

import { addOutline } from "ionicons/icons";

export default {
  props: ["chargeable", "title"],

  components: {
    BaseLayout,
    BaseModal,
    ListChargeableStudent,
    CreateChargeableStudent,
    IonGrid,
    IonRow,
    IonCol,
    IonFab,
    IonFabButton,
    IonIcon,
    IonModal,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      //   title: this.title,
      backLink: "chargeable",
      reloadable: true,

      createModalState: false,

      addOutline,
    };
  },

  computed: {
    resources() {
      return this.$store.getters["chargeableStudent/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
    loadedChargeable() {
      const chargeables = this.$store.getters["chargeable/resources"];
      const chargeable = chargeables.data.filter((item) => {
        return item.id == this.chargeable;
      });
      return chargeable[0];
    },
    isMandatory() {
      const mandatory =
        this.loadedChargeable.is_mandatory == true ? true : false;
      return mandatory;
    },
  },

  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async fetch(refresh = true) {
      await this.$store.dispatch("chargeableStudent/resources", {
        refresh: refresh,
        resourceId: this.chargeable,
      });
    },
    loadData(event) {
      this.fetch(false);
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("chargeableStudent/resources", {
        refresh: true,
        resourceId: this.chargeable,
      });
      if (event) {
        event.target.complete();
      }
    },
    async loadChargeable() {
      await this.$store.dispatch("chargeable/resources", { refresh: false });
    },

    setCreateModalState(state) {
      this.createModalState = state;
    },
  },

  created() {
    this.fetch();
    this.loadChargeable();
  },
};
</script>

<style scoped></style>
